export default "__VITE_ASSET__CgG0t4SP__"